import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgGoogle = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#4285F4"
        fillRule="evenodd"
        d="M19.53 12.466q-.001-.777-.132-1.493h-6.876v2.823h3.929A3.36 3.36 0 0 1 14.994 16v1.831h2.36c1.38-1.27 2.176-3.142 2.176-5.365"
        clipRule="evenodd"
      />
      <path
        fill="#34A853"
        fillRule="evenodd"
        d="M12.522 19.6c1.971 0 3.624-.654 4.832-1.769L14.994 16c-.653.438-1.49.697-2.472.697-1.901 0-3.51-1.284-4.084-3.01h-2.44v1.891a7.3 7.3 0 0 0 6.524 4.022"
        clipRule="evenodd"
      />
      <path
        fill="#FBBC05"
        fillRule="evenodd"
        d="M8.438 13.687a4.4 4.4 0 0 1-.23-1.387c0-.481.084-.949.23-1.387V9.022h-2.44a7.297 7.297 0 0 0 0 6.557z"
        clipRule="evenodd"
      />
      <path
        fill="#EA4335"
        fillRule="evenodd"
        d="M12.522 7.903c1.072 0 2.034.369 2.79 1.092l2.095-2.094C16.142 5.723 14.49 5 12.522 5A7.3 7.3 0 0 0 6 9.022l2.439 1.891c.574-1.725 2.183-3.01 4.084-3.01"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgGoogle;
